function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#6e95ff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.19,4.5c-1.13,0-2.04,.92-2.04,2.04s.86,2,1.99,2.04c.03,0,.07,0,.09,0h.03c1.1-.04,1.96-.93,1.97-2.04,0-1.13-.92-2.04-2.04-2.04Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.66,9.87c-1.36-.91-3.57-.91-4.94,0-.62,.41-.96,.97-.96,1.57s.34,1.15,.95,1.56c.68,.46,1.58,.69,2.47,.69s1.79-.23,2.47-.69c.61-.41,.95-.97,.95-1.57,0-.6-.34-1.15-.95-1.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,6.79c.07,.83-.52,1.56-1.35,1.66h-.02s-.05,0-.07,0c-.42,.02-.8-.11-1.09-.36,.44-.4,.7-.99,.64-1.63-.03-.35-.15-.67-.33-.94,.16-.08,.35-.13,.55-.15,.84-.07,1.59,.55,1.67,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51,11.06c-.04,.47-.34,.88-.85,1.16-.49,.27-1.1,.39-1.71,.38,.35-.32,.56-.71,.59-1.13,.05-.6-.24-1.18-.81-1.65-.33-.26-.71-.46-1.12-.61,1.08-.31,2.43-.1,3.26,.57,.45,.36,.68,.81,.63,1.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.26,
    y: 8.41,
    width: 1.56,
    height: 1.56,
    rx: 0.78,
    ry: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.98,
    y: 8.41,
    width: 1.56,
    height: 1.56,
    rx: 0.78,
    ry: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.69,
    y: 8.41,
    width: 1.56,
    height: 1.56,
    rx: 0.78,
    ry: 0.78,
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLink);
export default __webpack_public_path__ + "static/media/profile_link.a520c1c962223b5702c3a31495131ac3.svg";
export { ForwardRef as ReactComponent };